import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      emoji: '🔌',
      title: 'Connect Your Fleet',
      description: 'Sign up and connect your drivers and load sources.'
    },
    {
      number: '2',
      emoji: '🚚',
      title: 'Assign your loads',
      description: 'Use our smart AI match system to find the best available loads.'
    },
    {
      number: '3',
      emoji: '📊',
      title: 'Track & Optimize in Real-Time',
      description: 'Get updates and reroute your fleet as conditions change.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl lg:text-5xl font-bold text-center mb-16 text-gray-900">
          How Our System Works
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative bg-white border-2 border-gray-200 p-8 rounded-2xl hover:border-purple-500 hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <div className="absolute -top-4 -right-4 bg-gradient-to-br from-purple-600 to-purple-500 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                {step.number}
              </div>
              
              <div className="bg-gradient-to-br from-purple-600 to-purple-500 text-white w-16 h-16 rounded-xl flex items-center justify-center mb-6 text-3xl">
                {step.emoji}
              </div>
              
              <h3 className="text-xl font-bold mb-3 text-gray-900">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
